<template>
  <a-row :gutter="8" :class="getScreen ? 'm-list-wrapper' : 'd-list-wrapper'">
    <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
      <a-card :loading="loading">
        <div slot="title"><a-icon type="file-search" />&nbsp; Search</div>
        <ul class="m-list-wrapper">
          <li>
            <a-input-search v-model="quickSearch" placeholder="Quick Search" />
          </li>
          <li>
            <a-collapse activeKey="0">
              <a-collapse-panel key="0">
                <span slot="header">Search More...</span>
                <div class="m-form-item-wrapper">
                  <label for="tanggalTransaksi">Transaction Date</label>
                  <a-date-picker placeholder="Select Date" v-model="filter.searchDate" format="DD-MM-YYYY" allowClear />
                </div>
                <div class="m-form-item-wrapper">
                  <label>Type</label>
                  <a-select placeholder="Select Type" v-model="filter.type" class="width-full" allowClear>
                    <a-select-option value="Winner">
                      Winner
                    </a-select-option>
                    <a-select-option value="Companion">
                      Companion
                    </a-select-option>
                  </a-select>
                </div>
              </a-collapse-panel>
            </a-collapse>
          </li>
        </ul>
      </a-card>
    </a-col>
    <a-col :xs="{ span: 24 }" :lg="{ span: 16 }">
      <DataListSlot title="Guaranteed Return List" createLink="bidBond-create-mar" manifestLink="bidBond-manifest-mar"
        editLink="bidBond-edit-mar" :disabledCreateEditLink="!allowCreate" :fileStatus="true" :dataList="datasource"
        :loading="loading">
        <!-- <div slot="status" slot-scope="data">
          <status :status="data.item.closeStatus" />
        </div> -->
        <div class="m-display-flex flex-row space-between" slot="status_file" slot-scope="data">
          <span class="margin-remove">BKM</span>
          <a-tag :color="data.item.bkm == 'File Have Been Upload' ? 'green' : ''" class="margin-remove">
            {{ data.item.bkm }}

          </a-tag>
        </div>
      </DataListSlot>
    </a-col>
  </a-row>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import _ from "lodash";

export default {
  name: "bidBond",
  mixins: [CurrencyFormat],
  data() {
    return {
      loading: false,
      rawData: [],
      filter: {
        searchDate: null,
        type: undefined,
      },
      quickSearch: "",
      allowCreate: this.$route.meta.ismarketing,
    };
  },
  computed: {
    ...mapGetters([
      "getScreen",
      "getAuth",
      "getListBidBond",
      "getDefaultDateFormat",
      "getStandartFormatDate",
      "getStatus",
    ]),
    datasource() {
      let outputData = this.rawData;

      if (this.quickSearch) {
        outputData = _.filter(
          outputData,
          (obj) =>
            obj.keyword &&
            obj.keyword.indexOf(this.quickSearch.toLowerCase()) >=
            0
        );
      }

      if (this.filter.searchDate) {
        let filter = moment(this.filter.searchDate).format(
          this.getStandartFormatDate
        );
        outputData = _.filter(outputData, (obj) =>
          moment(obj.create_dt).format(this.getStandartFormatDate) == filter);
      }

      if (this.filter.type) {
        outputData = _.filter(
          outputData,
          (obj) => obj.type && (obj.type.toLowerCase() == this.filter.type.toLowerCase())
        );
      }

      return outputData;
    },
  },
  mounted() {
    this.fetch();
  },
  methods: {
    moment,
    fetch() {
      this.loading = true;
      this.$store
        .dispatch("getListBidBond", { auth: this.getAuth })
        .then((res) => {
          res.forEach((data) => {
            this.rawData.push({
              id: data.bidbond_id,
              title: data.bidbond_no,
              create_dt: data.create_dt,
              bkm: data.bkm,
              type: data.type,
              keyword:
                data.bidbond_no.toLowerCase() + " " +
                data.guarantee_no.toLowerCase() + " " +
                data.tlc_create.toLowerCase() + " " +
                moment(data.create_dt).format('DD-MM-YYYY') + " " +
                this.formatCurrency("IDR", data.nominal).toLowerCase() + " " +
                data.type.toLowerCase() + " " +
                data.bank_nm.toLowerCase() + " " +
                data.rekening_no.toLowerCase(),
              subdesc: [
                "No: " + data.guarantee_no,
                data.tlc_create + " | " + moment(data.create_dt).format('DD-MM-YYYY'),
                [

                  {
                    label: data.type.toLowerCase() == "winner" ? "Companion Name" : "",
                    value: data.type.toLowerCase() == "winner" ? data.companion_nm : "",
                  }
                  , {
                    label: "Guarantee Period",
                    value: moment(data.start_due_dt).format('DD-MM-YYYY') + " ~ "
                      + moment(data.end_due_dt).format('DD-MM-YYYY'),
                  },
                  {
                    label: "Project Name",
                    value: data.name_project,
                  },
                  {
                    label: "Type",
                    value: data.type,
                  },
                  {
                    label: "Nominal",
                    value: this.formatCurrency("IDR", data.nominal),
                  },
                  {
                    label: "Bank Account",
                    value: data.bank_nm,
                  },
                  {
                    label: "",
                    value: "( " + data.rekening_no + " )",
                  },
                ],
              ],
              timeline: data.status_app ? JSON.parse(data.status_app) : [],
            });
          });
          this.loading = false;
        });
    },
    handleRevise(item) {
      this.$router.push({
        name: "financing-edit",
        params: { id: item.id, type: "revisi" },
      });
    },
    handleAmandemen(item) {
      this.$router.push({
        name: "financing-edit",
        params: { id: item.id, type: "amandemen" },
      });
    },
  },
};
</script>

<style></style>
